export default __webpack_public_path__ + "static/media/subcategory_car_9.d35fb825.png";